import React from 'react';
import { useTranslation } from 'react-i18next';
import Select, { components } from 'react-select';

// Custom Option with checkbox
const CheckboxOption = (props) => {
  const { data, isSelected, innerRef, innerProps } = props;

  return (
    <div
      ref={innerRef}
      {...innerProps}
      style={{ padding: '8px 12px', display: 'flex', alignItems: 'center' }}
    >
      <input
        type="checkbox"
        checked={isSelected}
        readOnly
        style={{ marginRight: 8 }}
      />
      <label>{data.label}</label>
    </div>
  );
};

export const customDropDownStyles = ({ width, backgroundColor, isInvalid }) => {
  return {
    control: (provided) => ({
      ...provided,
      borderRadius: '.5rem',
      width: width || provided.width,
      backgroundColor: backgroundColor || provided.backgroundColor,
      borderColor: isInvalid ? 'red' : provided.borderColor,
    }),
    multiValue: (provided) => ({
      ...provided,
      borderRadius: '.5rem',
      backgroundColor: backgroundColor || provided.backgroundColor,
    }),
    multiValueRemove: (provided) => ({
      ...provided,
      borderRadius: '.5rem',
    }),
    placeholder: (provided) => ({
      ...provided,
      borderRadius: '.5rem',
      backgroundColor: backgroundColor || provided.backgroundColor,
    }),
    menu: (provided) => ({
      ...provided,
      backgroundColor: backgroundColor || provided.backgroundColor,
      width: '100%',
      textAlign: 'start',
    }),
    singleValue: (provided, state) => {
      const opacity = state.isDisabled ? 0.5 : 1;
      const transition = 'opacity 300ms';
      return {
        ...provided,
        opacity,
        transition,
      };
    },
  };
};

const EditableCheckDropdown = (props) => {
  const { t } = useTranslation();
  const {
    onChange,
    options,
    placeholder = 'Select an Option',
    isMultiSelect = false,
    disabled = false,
    width,
    isInvalid,
    backgroundColor,
    optionColor,
    value,
    valueKey = 'value',
  } = props;

  let selectedValue = [];

  if (isMultiSelect) {
    if (Array.isArray(value)) {
      selectedValue = value.map((val) => {
        const option = options.find((opt) => opt[valueKey] === val);
        return option || { label: val, value: val };
      });
    }
  } else {
    const found = options.find((option) => option[valueKey] === value);
    selectedValue = found || (value ? { label: value, value: value } : null);
  }

  return (
    <Select
      isDisabled={disabled}
      isMulti={isMultiSelect}
      closeMenuOnSelect={!isMultiSelect}
      hideSelectedOptions={false}
      components={isMultiSelect ? { Option: CheckboxOption } : {}}
      onChange={onChange}
      value={selectedValue}
      options={options}
      placeholder={t(placeholder)}
      theme={(theme) => ({
        ...theme,
        borderRadius: 0,
        colors: {
          ...theme.colors,
          primary25: '#61DAFB',
          primary: '#61DAFB',
        },
      })}
      styles={{
        ...customDropDownStyles({ width, backgroundColor, isInvalid }),
        multiValue: (styles) => ({
          ...styles,
          backgroundColor: optionColor || styles.backgroundColor,
        }),
      }}
    />
  );
};

export default EditableCheckDropdown;
